var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckEvaluate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#FFC97A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5C4.5625 19.5 0.125 15.125 0 9.75C0 9.8125 0 9.875 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 9.9375 20 9.875 20 9.75C19.875 15.1875 15.4375 19.5 10 19.5Z",
    fill: "#FFC97A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 6.5L15.375 6.1875C15.25 6.0625 15.125 6 15 6C14.875 6 14.6875 6.0625 14.625 6.1875L9.1875 11.625L6.25 8.75C6.0625 8.5625 5.6875 8.5625 5.4375 8.75L5.125 9.0625C4.9375 9.25 4.9375 9.625 5.125 9.8125L8.5625 13.25C8.6875 13.375 8.9375 13.5 9.125 13.5C9.3125 13.5 9.5625 13.4375 9.6875 13.25L15.6875 7.25C15.8125 7.125 15.875 7 15.875 6.875C15.875 6.75 15.8125 6.625 15.6875 6.5Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEvaluate);
export default __webpack_public_path__ + "static/media/check-evaluate.991f3e100afa513633aad2534faa3544.svg";
export { ForwardRef as ReactComponent };